import { Component, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonComponent } from '../../shared/components/custom-button/button.component';
import { TableComponent } from '../../shared/components/custom-table/table.component';
import { SubmitEventComponent } from '../../shared/components/dialog/submit-event/submit-event.component';
import { CustomToastComponent } from '../../shared/components/toast/custom-toast.component';
import { HttpService } from '../../shared/services/http.service';

interface APIResponse {
    status: boolean;
    message: string;
    data: any[];
}
@Component({
    selector: 'app-dashboard-home',
    standalone: true,
    imports: [
        TableComponent,
        ButtonComponent
    ],
    templateUrl: './point-and-achievements.component.html',
    styleUrls: ['./point-and-achievements.component.scss']
})
export class PointAndAchievementsComponent {
    @ViewChild('actionButtons') actionButtonsTemplate!: TemplateRef<any>;

    columns: string[] = ['activity', 'notes', 'location', 'point'];
    data: any = [];
    tableData: any[] = [];
    loading = false;

    constructor(
        private route: ActivatedRoute,
        private dialog: MatDialog,
        public router: Router,
        private httpService: HttpService,
        private snackBar: MatSnackBar,

    ) {

        this.fetchPointsDetails()
        this.fetchPointstable()
    }


    onView(user: any): void {

    }

    fetchPointsDetails(): void {
        this.loading = true;
        this.httpService.get<APIResponse>('studentpdp/summary').subscribe({
            next: (response) => {
                this.data = response.data
            },
            error: (err) => {
                this.loading = false
                this.showErrorToast(err.messasge || 'Something went wrong. Please try again later.');
            },
            complete: () => (this.loading = false),
        });
    }

    fetchPointstable(): void {
        this.loading = true;
        this.httpService.get<APIResponse>('studentpdp/activities').subscribe({
            next: (response) => {
                this.tableData = response.data.map(item => {
                    return {
                        id: item?.registrationId,
                        activity: item?.activity,
                        notes: item?.notes,
                        location: item?.location,
                        point: item?.points
                    };
                });
            },
            error: (err) => {
                this.loading = false
                this.showErrorToast(err.messasge || 'Something went wrong. Please try again later.');
            },
            complete: () => (this.loading = false),
        });
    }

    openExternalEventDialog(schoolToEdit: any = null, isEdit: boolean = false, width: string = '43.125rem'): void {
        const dialogRef = this.dialog.open(SubmitEventComponent, {
            width: width,
            maxWidth: '90vw',
            minWidth: '300px',
            data: { initialData: schoolToEdit, EditMode: isEdit },
            disableClose: true,
            autoFocus: false,
            panelClass: 'custom-dialog-container'
        });

        dialogRef.afterClosed().subscribe(result => {
            // if (result) {
            //     this.fetchSchools();
            // }
            // this.editingSchool = null;
        });
    }

    private showSuccessToast(message: string): void {
        this.snackBar.openFromComponent(CustomToastComponent, {
            data: { message },
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['no-padding-snackbar', 'success-toast']
        });
    }

    private showErrorToast(message: string | null | undefined): void {
        if (!message) return;
        this.snackBar.openFromComponent(CustomToastComponent, {
            data: { message },
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['no-padding-snackbar', 'error-toast']
        });
    }

}
